import React from "react";

const SelectVrm = (props) => {
  return (
    <div className="container-fluid">
      <h1>Enter your vehicle registration</h1>
      <div className="row row-qr mx-auto d-block">
        <input type="text" maxLength={12} onChange={(e) => props.onChange(e.target.value)} style={{ textTransform: "uppercase" }} />
      </div>
      <button type="button" className="btn btn-warning btn-qr" onClick={props.next} disabled={props.disabled}>
        Next
      </button>
    </div>
  );
};

export default SelectVrm;
